<template>
  <div class="page_box">
    <div class="page_option_box">
      <div class="option_box">
        <input
          type="file"
          id="riskFile"
          accept=".xls,.xlsx"
          @change="importPatrolRegion($event)"
        />

        <el-button
          type="primary"
          plain
          size="mini"
          icon="el-icon-bottom-right"
          @click="selectFileImport()"
          >导入</el-button
        >
        <el-button
          type="primary"
          plain
          size="mini"
          icon="el-icon-download"
          @click="
            $Common.fileDownloads(
              $store.state.select.downloadFileData.healthTemplate
            )
          "
          >下载</el-button
        >
      </div>
      <div class="search_box">
        <el-input
          v-model.trim="requestData.studentName"
          placeholder="请输入学生姓名"
          clearable
          size="mini"
        ></el-input>
        <el-date-picker
          v-model="requestData.specificDate"
          type="date"
          size="mini"
          clearable
          placeholder="请选择日期"
          format="yyyy 年 MM 月 dd 日"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
        <el-button
          size="mini"
          type="primary"
          plain
          icon="el-icon-search"
          @click="searchData"
          >搜索</el-button
        >
      </div>
    </div>
    <div class="page_table_box">
      <div class="school_table_box">
        <el-table
          :data="tableData"
          height="100%"
          class="table_box"
          :header-cell-style="{ background: '#E2EEFF', color: '#474859' }"
        >
          <el-table-column label="序号" width="70" fixed align="center">
            <template slot-scope="scope">
              {{
                requestData.pageSize * (requestData.pageNum - 1) +
                  scope.$index +
                  1
              }}
            </template>
          </el-table-column>
          <el-table-column
            prop="grade"
            label="所属年级"
            width="80"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="team"
            label="所属班级"
            width="80"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="name"
            label="学生名称"
            width="80"
            align="center"
          >
          </el-table-column>
          <el-table-column label="性别" width="80" align="center">
            <template slot-scope="scope">
              {{
                $Common.getDataName(
                  $store.state.select.personnelSexTwo,
                  scope.row.gender
                )
              }}
            </template>
          </el-table-column>
          <el-table-column prop="age" label="年龄" width="80" align="center">
          </el-table-column>
          <el-table-column
            prop="onsetTime"
            label="发病时间"
            width="120"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="symptom"
            label="症状"
            show-overflow-tooltip
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="hospitalDiagnosis"
            label="医院诊断情况"
            show-overflow-tooltip
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="handlingSituation"
            label="处理情况"
            show-overflow-tooltip
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="isNewCrown"
            label="有无感染新冠肺炎"
            width="100"
            show-overflow-tooltip
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="specificSituation"
            label="具体情况"
            show-overflow-tooltip
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="haveHistoryResidence"
            label="14日内本人或家人是否有旅居史"
            width="120"
            align="center"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="startAndEndTime"
            label="具体行程及起止时间"
            width="180"
            align="center"
          >
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination_box">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="requestData.pageNum"
          :page-size="requestData.pageSize"
          layout="total, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "HealthChecklist",
  data() {
    return {
      requestData: {
        pageNum: 1,
        pageSize: 20,
        schoolId: parseInt(this.$store.state.schoolId),
        specificDate: "",
        studentName: ""
      },
      tableData: [],
      total: 0
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    searchData() {
      this.requestData.pageNum = 1;
      this.getList();
    },
    async getList() {
      if (!this.requestData.specificDate) {
        this.requestData.specificDate = ''
      }
      let res = await this.$Http.getHealthDataList(this.requestData);
      if (res.code == 200) {
        this.tableData = res.data.list || [];
        this.total = res.data.total || 0;
      } else if (res.code == 101) {
        this.tableData = [];
        this.total = 0;
      } else {
        this.tableData = [];
        this.total = 0;
      }
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.requestData.pageNum = val;
      this.getList();
    },
    // 导入健康排查表
    async importPatrolRegion() {
      var fileUpload = event.target.files[0];
      if (!fileUpload) {
        return;
      }
      var requestData = {
        file: fileUpload
      };
      var newData = {
        schoolId: this.$store.state.schoolId,
        file: fileUpload
      };
      let res = await this.$Http.importHealthList(newData, true);
      // console.log(res);
      document.getElementById("riskFile").value = null;

      if (res.code == 200) {
        this.$message({
          type: "success",
          message: "导入成功"
        });
        this.getList();
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    // 选择文件导入
    selectFileImport() {
      document.getElementById("riskFile").click();
    }
  },
  computed: {
    // genderList() {}
  }
};
</script>
